import { AuthGuard } from './authentication/authGuard.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { SharedModule } from './shared/shared.module';
import { BreadcrumbsComponent } from './layouts/admin/breadcrumbs/breadcrumbs.component';
import { TitleComponent } from './layouts/admin/title/title.component';
import { ScrollModule} from './scroll/scroll.module';
import { LocationStrategy, PathLocationStrategy} from '@angular/common';
import { AuthenticationModule } from './authentication/authentication.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import { TokenInterceptor} from './authentication/tokenInterceptor.service';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { FakeDataService } from './in-memory-api/fake-data.service';
import { environment } from 'environments/environment.prod';
import { CalendarModule } from 'angular-calendar';
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { GenericService } from './core/generic.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChartModule } from 'angular-highcharts';
import { EphemerideService } from "app/core/ephemeride.service";
import { AjoutEpheComponent } from './layouts/admin/ajout-ephe/ajout-ephe.component';
import { PatientService } from './core/patient.service';
import { NgbDateFRParserFormatter } from './ngb-date-fr-parser-formatter';
import { ShowephemerideComponent } from './layouts/admin/showephemeride/showephemeride.component';
import { PersonnelService } from './core/personnels.service';
import { NotificationsService } from './utils/notifications.service';
import { AjoutanticoagulantComponent } from './ajoutanticoagulant/ajoutanticoagulant.component';

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    BreadcrumbsComponent,
    TitleComponent,
    AjoutEpheComponent,
    ShowephemerideComponent,
    AjoutanticoagulantComponent
    ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AuthenticationModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes),
    HttpModule,
    ScrollModule,
    HttpClientModule,
    environment.production
      ? []
      : HttpClientInMemoryWebApiModule.forRoot(FakeDataService),
    CalendarModule.forRoot(),
    NgbModule.forRoot(),
    NgbModalModule.forRoot(),
    NgSelectModule,
    FormsModule,
    ChartModule
  ],
  exports: [ScrollModule],
  providers: [
    { provide: LOCALE_ID, useValue: "fr-FR" },
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    AuthGuard,
    GenericService,
    EphemerideService,
    PatientService,
    NgbDateFRParserFormatter,
    NotificationsService,
    PersonnelService,
  ],
  entryComponents: [AjoutEpheComponent, ShowephemerideComponent],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/app.module.ts